/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */

export type ReportsFindCoordinatesCategoryOfTestItem =
  (typeof ReportsFindCoordinatesCategoryOfTestItem)[keyof typeof ReportsFindCoordinatesCategoryOfTestItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReportsFindCoordinatesCategoryOfTestItem = {
  direct: 'direct',
  indirect: 'indirect',
  observation: 'observation',
  others: 'others',
} as const;
